import iconWhatsapp from '../../assets/images/whatsapp-logo.png';
import { motion } from 'framer-motion';
import './style.css';


function WhatsappButton(){
    return <a href="https://api.whatsapp.com/send?phone=541130720821" target="_blank"><motion.img whileTap={{scale: 0.95, transition: { duration: 0.3 }}} whileHover={{scale: 1.05, transition: { duration: 0.3 }}}src={iconWhatsapp} className="btn-whatsapp"/></a>
}

export default WhatsappButton;